import React, { useEffect, useState, useRef } from "react"
import MetaTags from "react-meta-tags"
import PropTypes from "prop-types"
import { withRouter, Link } from "react-router-dom"
import { isEmpty } from "lodash"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
} from "react-bootstrap-table2-paginator"
import * as Yup from "yup"
import { useFormik } from "formik"
import DeleteModal from "../../components/Common/DeleteModal"

import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"

import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Badge,
  UncontrolledTooltip,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  Input,
  FormFeedback,
  Label,
} from "reactstrap"

//redux
import { useSelector, useDispatch } from "react-redux"

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"

import {
  getStores as onGetStores,
  getCompanies as onGetCompanies,
  getBusinesses as onGetBusinesses,
  getRegions as onGetRegions,
  addNewStore as onAddNewStore,
  updateStore as onUpdateStore,
  deleteStore as onDeleteStore,
} from "store/actions"
import StoreDetailsModal from "./StoreDetailsModal"

const Stores = props => {
  const dispatch = useDispatch()

  const [storeList, setStoreList] = useState([])
  const [companyList, setCompanyList] = useState([])
  const [businessList, setBusinessList] = useState([])
  const [regionList, setRegionList] = useState([])
  const [store, setStore] = useState(null)
  const [modal, setModal] = useState(false)
  const [modal1, setModal1] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  //delete store
  const [deleteModal, setDeleteModal] = useState(false)

  const { stores } = useSelector(state => ({
    stores: state.stores.stores,
  }))

  const { regions } = useSelector(state => ({
    regions: state.regions.regions,
  }))

  const { companies } = useSelector(state => ({
    companies: state.companies.companies,
  }))

  const { businesses } = useSelector(state => ({
    businesses: state.businesses.businesses,
  }))

  // validation
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      _id: (store && store._id) || "",
      name: (store && store.name) || "",
      description: (store && store.description) || "",
      company:
        (store && store.company) ||
        (companyList.length !== 0 && companyList[0]._id) ||
        "",
      business: store && store.business && isEdit ? store.business : "",
      region: store && store.region && isEdit ? store.region : "",
      deleted: (store && store?.deleted) || "Active",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Please Enter Your Store Name"),
      description: Yup.string().required("Please Enter Your Store Description"),
      company: Yup.string().required("Please Select a Company"),
      business: Yup.string().required("Please Select a Business"),
      region: Yup.string().required("Please Select a Region"),
      deleted: Yup.string().required("Please Enter Your Store Status"),
    }),
    onSubmit: values => {
      if (isEdit) {
        console.log("EDITING STORE: ", values)
        const updateStore = {
          _id: store._id,
          name: values.name,
          description: values.description,
        }
        // update store
        dispatch(onUpdateStore(updateStore))
        validation.resetForm()
      } else {
        const newStore = {
          name: values["name"],
          description: values["description"],
          company: values["company"],
          business: values["business"],
          region: values["region"],
          deleted: false,
        }
        console.log("CREATING STORE: ", values)
        // save new store
        dispatch(onAddNewStore(newStore))
        validation.resetForm()
      }
      toggle()
      dispatch(onGetStores())
    },
  })

  const selectRow = {
    mode: "checkbox",
  }

  const { values: formValues } = validation

  //pagination customization
  const pageOptions = {
    sizePerPage: 10,
    totalSize: stores.length, // replace later with size(stores),
    custom: true,
  }
  const { SearchBar } = Search

  const toggleViewModal = () => setModal1(!modal1)

  const StoreColumns = toggleModal => [
    {
      dataField: "name",
      text: "Name",
      sort: true,
    },
    {
      dataField: "description",
      text: "Description",
      sort: true,
    },
    {
      dataField: "companyName",
      text: "Company",
      sort: true,
    },
    {
      dataField: "businessName",
      text: "Business",
      sort: true,
    },
    {
      dataField: "regionName",
      text: "Region",
      sort: true,
    },
    {
      dataField: "deleted",
      text: "Status",
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, row) => (
        <Badge
          className={"font-size-12 badge-soft-" + row.badgeclass}
          color={row?.deleted ? "danger" : "success"}
          pill
        >
          {row?.deleted ? "Deleted" : "Active"}
        </Badge>
      ),
    },
    {
      dataField: "view",
      isDummyField: true,
      text: "View Details",
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, store) => (
        <Button
          type="button"
          color="primary"
          className="btn-sm btn-rounded"
          onClick={() => handleStoreDetails(store)}
        >
          View Details
        </Button>
      ),
    },
    {
      dataField: "action",
      isDummyField: true,
      text: "Action",
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, store) => (
        <>
          <div className="d-flex gap-3">
            <Link
              to="#"
              className="text-success"
              onClick={() => handleStoreClick(store)}
            >
              <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
              <UncontrolledTooltip placement="top" target="edittooltip">
                Edit
              </UncontrolledTooltip>
            </Link>
            <Link
              to="#"
              className="text-danger"
              onClick={() => onClickDelete(store)}
            >
              <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
              <UncontrolledTooltip placement="top" target="deletetooltip">
                Delete
              </UncontrolledTooltip>
            </Link>
          </div>
        </>
      ),
    },
  ]

  const toggle = () => {
    if (modal) {
      setModal(false)
      setStore(null)
    } else {
      setModal(true)
    }
  }

  const handleStoreClick = arg => {
    const store = arg

    setStore({
      _id: store._id,
      name: store.name,
      description: store.description,
      company: store.company,
      companyName: store.companyName,
      deleted: store?.deleted,
      business: store.business,
      businessName: store.businessName,
      region: store.region,
      badgeclass: store.badgeclass,
    })
    console.log("STORE: ", store)

    setIsEdit(true)

    toggle()
  }

  const handleStoreDetails = arg => {
    const store = arg

    setStore({
      _id: store._id,
      name: store.name,
      description: store.description,
      company: store.company,
      companyName: store.companyName,
      business: store.business,
      businessName: store.businessName,
      region: store.region,
      regionName: store.regionName,
      deleted: store?.deleted,
      badgeclass: store.badgeclass,
    })
    console.log("Store: ", store)

    toggleViewModal()
  }

  var node = useRef()
  const onPaginationPageChange = page => {
    if (
      node &&
      node.current &&
      node.current.props &&
      node.current.props.pagination &&
      node.current.props.pagination.options
    ) {
      node.current.props.pagination.options.onPageChange(page)
    }
  }

  const onClickDelete = store => {
    setStore(store)
    setDeleteModal(true)
  }

  const handleDeleteStore = () => {
    if (store._id) {
      dispatch(onDeleteStore(store))
      onPaginationPageChange(1)
      setDeleteModal(false)
    }
  }
  const handleStoreClicks = () => {
    setIsEdit(false)
    toggle()
  }

  const defaultSorted = [
    {
      dataField: "_id",
      store: "desc",
    },
  ]

  useEffect(() => {
    if (stores && !stores.length) {
      dispatch(onGetStores())
    }
  }, [dispatch, stores])

  useEffect(() => {
    if (companies && !companies.length) {
      dispatch(onGetCompanies())
    }
  }, [dispatch, companies])

  useEffect(() => {
    if (businesses && !businesses.length) {
      dispatch(onGetBusinesses())
    }
  }, [dispatch, businesses])

  useEffect(() => {
    if (regions && !regions.length) {
      dispatch(onGetRegions())
    }
  }, [dispatch, regions])

  useEffect(() => {
    if (companies) {
      const activeCompanies = companies.filter(company => !company?.deleted)
      setCompanyList(activeCompanies)
    }
  }, [companies])

  useEffect(() => {
    if (businesses && formValues.company) {
      const activeBusinesses = businesses.filter(
        business => !business?.deleted && business.company === formValues.company
      )
      setBusinessList(activeBusinesses)
    }
  }, [businesses, formValues.company])

  useEffect(() => {
    if (regions && formValues.business) {
      const activeRegions = regions.filter(
        regions => !regions?.deleted && regions.business === formValues.business
      )
      setRegionList(activeRegions)
    }
  }, [regions, formValues.business])

  useEffect(() => {
    if (stores && companies && businesses && regions) {
      const newStores = stores
        .filter(store => !store?.deleted)
        .map(store => ({
          ...store,
          companyName: companies.find(company => company._id === store.company)
            ?.name,
          businessName: businesses.find(
            business => business._id === store.business
          )?.name,
          regionName: regions.find(region => region._id === store.region)?.name,
        }))
      setStoreList(newStores)
    }
  }, [businesses, companies, regions, stores])

  return (
    <React.Fragment>
      <StoreDetailsModal
        isOpen={modal1}
        toggle={toggleViewModal}
        store={store}
      />
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteStore}
        onCloseClick={() => setDeleteModal(false)}
      />
      <div className="page-content">
        <MetaTags>
          <title>Stores</title>
        </MetaTags>
        <Container fluid>
          <Breadcrumbs title="Stores" breadcrumbItem="Stores" />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <PaginationProvider
                    pagination={paginationFactory(pageOptions)}
                    keyField="id"
                    columns={StoreColumns(toggle)}
                    data={storeList}
                  >
                    {({ paginationProps, paginationTableProps }) => (
                      <ToolkitProvider
                        keyField="id"
                        data={storeList}
                        columns={StoreColumns(toggle)}
                        bootstrap4
                        search
                      >
                        {toolkitProps => (
                          <React.Fragment>
                            <Row className="mb-2">
                              <Col sm="4">
                                <div className="search-box me-2 mb-2 d-inline-block">
                                  <div className="position-relative">
                                    <SearchBar {...toolkitProps.searchProps} />
                                    <i className="bx bx-search-alt search-icon" />
                                  </div>
                                </div>
                              </Col>
                              <Col sm="8">
                                <div className="text-sm-end">
                                  <Button
                                    type="button"
                                    color="success"
                                    className="btn-rounded  mb-2 me-2"
                                    onClick={handleStoreClicks}
                                  >
                                    <i className="mdi mdi-plus me-1" />
                                    Add Store
                                  </Button>
                                </div>
                              </Col>
                            </Row>
                            <Row>
                              <Col xl="12">
                                <div className="table-responsive">
                                  <BootstrapTable
                                    keyField="id"
                                    responsive
                                    bstoreed={false}
                                    striped={false}
                                    defaultSorted={defaultSorted}
                                    selectRow={selectRow}
                                    classes={
                                      "table align-middle table-nowrap table-check"
                                    }
                                    headerWrapperClasses={"table-light"}
                                    {...toolkitProps.baseProps}
                                    {...paginationTableProps}
                                    ref={node}
                                  />
                                </div>
                                <Modal isOpen={modal} toggle={toggle}>
                                  <ModalHeader toggle={toggle} tag="h4">
                                    {!!isEdit ? "Edit Store" : "Add Store"}
                                  </ModalHeader>
                                  <ModalBody>
                                    <Form
                                      onSubmit={e => {
                                        e.preventDefault()
                                        validation.handleSubmit()
                                        return false
                                      }}
                                    >
                                      <Row form>
                                        <Col className="col-12">
                                          <div className="mb-3">
                                            <Label className="form-label">
                                              Store Name
                                            </Label>
                                            <Input
                                              name="name"
                                              type="text"
                                              validate={{
                                                required: { value: true },
                                              }}
                                              onChange={validation.handleChange}
                                              onBlur={validation.handleBlur}
                                              value={
                                                validation.values.name || ""
                                              }
                                              invalid={
                                                validation.touched.name &&
                                                validation.errors.name
                                                  ? true
                                                  : false
                                              }
                                            />
                                            {validation.touched.name &&
                                            validation.errors.name ? (
                                              <FormFeedback type="invalid">
                                                {validation.errors.name}
                                              </FormFeedback>
                                            ) : null}
                                          </div>
                                          <div className="mb-3">
                                            <Label className="form-label">
                                              Store Description
                                            </Label>
                                            <Input
                                              name="description"
                                              type="textarea"
                                              id="textarea"
                                              maxLength="225"
                                              rows="3"
                                              validate={{
                                                required: { value: true },
                                              }}
                                              onChange={validation.handleChange}
                                              onBlur={validation.handleBlur}
                                              value={
                                                validation.values.description ||
                                                ""
                                              }
                                              invalid={
                                                validation.touched
                                                  .description &&
                                                validation.errors.description
                                                  ? true
                                                  : false
                                              }
                                            />
                                            {validation.touched.description &&
                                            validation.errors.description ? (
                                              <FormFeedback type="invalid">
                                                {validation.errors.description}
                                              </FormFeedback>
                                            ) : null}
                                          </div>
                                          {!isEdit && (
                                            <div className="mb-3">
                                              <Label className="form-label">
                                                Company
                                              </Label>
                                              <Input
                                                name="company"
                                                type="select"
                                                className="form-select"
                                                onChange={
                                                  validation.handleChange
                                                }
                                                onBlur={validation.handleBlur}
                                                value={
                                                  validation.values.company ||
                                                  ""
                                                }
                                              >
                                                {companyList.map(
                                                  (company, index) => (
                                                    <option
                                                      value={company._id}
                                                      key={company._id}
                                                    >
                                                      {company.name}
                                                    </option>
                                                  )
                                                )}
                                              </Input>
                                            </div>
                                          )}

                                          {!isEdit &&
                                            businessList.length !== 0 && (
                                              <div className="mb-3">
                                                <Label className="form-label">
                                                  Business
                                                </Label>
                                                <Input
                                                  name="business"
                                                  type="select"
                                                  className="form-select"
                                                  onChange={
                                                    validation.handleChange
                                                  }
                                                  onBlur={validation.handleBlur}
                                                  value={
                                                    validation.values
                                                      .business || ""
                                                  }
                                                >
                                                  <option value="" key="none">
                                                    Select a business
                                                  </option>
                                                  {businessList.map(
                                                    (business, index) => (
                                                      <option
                                                        value={business._id}
                                                        key={business._id}
                                                      >
                                                        {business.name}
                                                      </option>
                                                    )
                                                  )}
                                                </Input>
                                              </div>
                                            )}
                                          {!isEdit && regionList.length > 0 && (
                                            <div className="mb-3">
                                              <Label className="form-label">
                                                Region
                                              </Label>
                                              <Input
                                                name="region"
                                                type="select"
                                                className="form-select"
                                                onChange={
                                                  validation.handleChange
                                                }
                                                onBlur={validation.handleBlur}
                                                value={
                                                  validation.values.region || ""
                                                }
                                              >
                                                <option value="" key="none">
                                                  Select a region
                                                </option>
                                                {regionList.map(
                                                  (region, index) => (
                                                    <option
                                                      value={region._id}
                                                      key={region._id}
                                                    >
                                                      {region.name}
                                                    </option>
                                                  )
                                                )}
                                              </Input>
                                            </div>
                                          )}
                                        </Col>
                                      </Row>
                                      <Row>
                                        <Col>
                                          <div className="text-end">
                                            <button
                                              type="submit"
                                              className="btn btn-success save-user"
                                            >
                                              Save
                                            </button>
                                          </div>
                                        </Col>
                                      </Row>
                                    </Form>
                                  </ModalBody>
                                </Modal>
                              </Col>
                            </Row>
                            <Row className="align-items-md-center mt-30">
                              <Col className="pagination pagination-rounded justify-content-end mb-2 inner-custom-pagination">
                                <PaginationListStandalone
                                  {...paginationProps}
                                />
                              </Col>
                            </Row>
                          </React.Fragment>
                        )}
                      </ToolkitProvider>
                    )}
                  </PaginationProvider>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

Stores.propTypes = {
  stores: PropTypes.array,
  onGetStores: PropTypes.func,
  onAddNewStore: PropTypes.func,
  onDeleteStore: PropTypes.func,
  onUpdateStore: PropTypes.func,
}

export default withRouter(Stores)
